<template>
  <b-card
    v-if="product"
    class="card-ui-components-container"
    :img-src="product.imagePath"
    :img-alt="product.image"
    img-left
  >
    <b-card-text>
      <b-icon-pencil @click="editData" />
      <b-icon-trash @click="deleteData(product.id,product.name_CH)" />
      <h5>{{ product.name_CH }}</h5>
      <h5>{{ product.name_EN }}</h5>

      <i v-if="myCategory">
        <img
          v-if="myCategory.iconPath"
          :src="myCategory.iconPath"
          :alt="myCategory.icon"
        >
        {{ myCategory.name_CH }}
      </i>
      <h6 v-else>
        <b-badge  variant="danger">此產品未被納入分類</b-badge>
      </h6>
      
      <p>{{ product.size }}</p>
    </b-card-text>
  </b-card>
</template>

<script>
  import { mapState, mapActions } from "vuex";

  export default {
    data() {
      return {};
    },
    props: {
      product: Object,
    },
    computed: {
      ...mapState("backend", ["AdminName", "categories"]),
      ...mapState("login", ["user"]),

      myCategory: function () {
        if (this.categories.length) {
          return this.categories.filter(
            (cate) => cate.id === this.product.cateId
          )[0];
        }
        return;
      },
    },
    methods: {
      ...mapActions("backend", ["addMission"]),

      editData: function () {
        this.$router.push({
          path: "/admin/add",
          query: { id: this.product.id },
        });
      },
      deleteData: function (id, name) {
        const ensure = confirm("確定要刪除這個品項嗎？");
        if (ensure) {
          let mission = {
            type: "del",
            date: new Date().getTime(),
            ownerId: this.user.id,
            supervisor: "",
            state: "pending",
            comment: "",
            product: name,
            itemID: id,
            Statement: this.product,
            system: 'Product'
          };
          console.log(mission);
          this.addMission(mission);
        }
      },
    },
  };
</script>
